import React, { useState } from "react";
import { StyledCardWIP } from "../../styled-components/StyledCardWIP.style";
import { StyledTablePage } from "../../styled-components/StyledTablePage.style";
import Flex from '@react-css/flex';

export const CardWIP = (props) => {
    const { item, history, empresa, indexTab, getCardId = { getCardId }, isFromPerito, params } = props;
    const tabIndex = indexTab ?? 0;
    return (
        <StyledCardWIP>
            <div className="card-align">
                <Flex className={'title-legend'}>
                    <div className="flex-title-center" style={{width: "100%"}} onClick={() => history.push(`/wip/detalhes?tabIndex=${tabIndex}&visao=${item.value[0]?.visao}&IdEmpresa=${empresa}${params}`)}>
                        <span className="legend-title-text-bold">{item.value[0]?.visao}</span>
                    </div>
                </Flex>

                <StyledTablePage>
                    <table className="table table-bordered table-width">
                        <thead>
                            <tr className="table-legend-info">
                                <th key='0'></th>
                                <th key='1'>Qtd.TS </th>
                                <th key='2'>Horas</th>
                                <th key='3'>Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr key={"-1"} className={'primeiro-ativo-wip'}>
                                <td className="text-center">Total</td>
                                <td className="text-center">{item.totalTimesheet}</td>
                                <td className="text-center">{item.totalHoras}</td>
                                <td className="text-center">{item.totalValor}</td>
                            </tr>
                            {item.value.map((visao, index) => (
                                <tr key={index}>
                                    <td className="text-center">{visao.sigla}</td>
                                    <td className="text-center">{visao.qtdTimesheet}</td>
                                    <td className="text-center">{visao.totalHorasFaturadas}</td>
                                    <td className="text-center">{visao.possuiDesconto ? "*" : ""} {visao.valorTotalFaturado}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </StyledTablePage>
            </div>
        </StyledCardWIP>
    );
};
